exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-curso[data-v-4a5d1d18]{width:250px;border-radius:15px}.card-curso[data-v-4a5d1d18]{border-radius:15px!important;border:0!important;width:250px;align-items:center;transition:.2s;z-index:0;margin:10px}.card-curso[data-v-4a5d1d18]:hover{box-shadow:-1px 11px 16px 1px rgba(0,0,0,.32);transition:.2s;transform:scaleX(1.05) scaleY(1.05);z-index:1}@media screen and (max-width:600px){.card-curso[data-v-4a5d1d18]{width:140px;margin:10px}.img-curso[data-v-4a5d1d18]{width:140px;border-radius:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a5d1d18","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/activities/Activity.vue
// module id = 405
// module chunks = 0